import React, { PropsWithChildren, useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'react-toastify';
import { ApiError } from '@area-restrita/client';
import { useInviteMember } from '@area-restrita/api-client/endpoints/memberships/memberships.gen';

import { Form } from '@/components/ui/form';

import { InviteForm, inviteSchema } from './schema';
import InviteDialogView from './view';

interface IProps extends PropsWithChildren {}

const InviteDialog: React.FC<IProps> = ({ children }) => {
  const form = useForm<InviteForm>({
    defaultValues: { email: '', roles: [] },
    resolver: zodResolver(inviteSchema),
  });

  const inviteMember = useInviteMember({
    mutation: {
      onSuccess: () => {
        toast.success('Membro convidado com sucesso');
        form.reset({});
      },
      onError: (error) => {
        const message =
          error instanceof ApiError && error.statusCode === 409
            ? error.message
            : 'Falha ao convidar membro';

        if (error instanceof ApiError && error.statusCode === 409) {
          form.setError('externalId', {
            type: 'manual',
            message,
          });
        }

        toast.error(message);
      },
    },
  });

  const onSubmit = useCallback<SubmitHandler<InviteForm>>(
    async (data) =>
      inviteMember.mutateAsync({
        data: { ...data, roles: data.roles.map((role) => role.value) },
      }),
    [inviteMember],
  );

  return (
    <Form {...form}>
      <InviteDialogView
        control={form.control}
        onSubmit={form.handleSubmit(onSubmit)}
        isLoading={form.formState.isSubmitting}
        onClose={form.reset}
      >
        {children}
      </InviteDialogView>
    </Form>
  );
};

export default InviteDialog;
